import React, { useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import '../ServicePage.css';

function CloudSolutions() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="service-page">
            <Container>
                <div className="service-header">
                    <h1 className="service-title gradient-text">Cloud Solutions</h1>
                    <p className="service-description">
                        Soluzioni cloud complete per modernizzare la tua infrastruttura IT con 
                        sicurezza, scalabilità e performance ottimali.
                    </p>
                </div>

                <Row className="mb-5">
                    <Col lg={12}>
                        <Card className="service-card">
                            <Card.Body>
                                <h2 className="section-title">Cos'è il Cloud Computing?</h2>
                                <p className="section-description">
                                    Il cloud computing è la distribuzione di servizi informatici (server, archiviazione, 
                                    database, rete, software, analisi e intelligence) tramite Internet per offrire 
                                    innovazione più rapida, risorse flessibili ed economie di scala. Invece di possedere 
                                    datacenter o server fisici, puoi accedere a servizi tecnologici come potenza di 
                                    calcolo, archiviazione e database su base as-needed da provider cloud.
                                </p>
                                
                                <div className="cloud-benefits">
                                    <Row>
                                        <Col md={6}>
                                            <div className="benefit-item">
                                                <i className="fas fa-chart-line text-primary"></i>
                                                <strong>Scalabilità</strong>
                                                <p>Risorse che crescono con il tuo business</p>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="benefit-item">
                                                <i className="fas fa-piggy-bank text-primary"></i>
                                                <strong>Riduzione Costi</strong>
                                                <p>Paghi solo per quello che usi</p>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="benefit-item">
                                                <i className="fas fa-shield-alt text-primary"></i>
                                                <strong>Sicurezza</strong>
                                                <p>Protezione enterprise-grade dei tuoi dati</p>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="benefit-item">
                                                <i className="fas fa-sync text-primary"></i>
                                                <strong>Backup Automatico</strong>
                                                <p>Disaster recovery e alta disponibilità</p>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mb-5">
                    <Col lg={12}>
                        <Card className="service-card highlight-card">
                            <Card.Body>
                                <h2 className="section-title">I Nostri Servizi Cloud</h2>
                                
                                <Row>
                                    <Col lg={6} className="mb-4">
                                        <div className="service-item">
                                            <div className="service-icon">
                                                <i className="fab fa-google text-primary"></i>
                                            </div>
                                            <h4>Gestione Google Cloud Platform</h4>
                                            <p>
                                                Configurazione, ottimizzazione e gestione completa di infrastrutture 
                                                esistenti su Google Cloud, inclusi Compute Engine, Cloud Storage, 
                                                BigQuery e servizi AI/ML.
                                            </p>
                                        </div>
                                    </Col>
                                    
                                    <Col lg={6} className="mb-4">
                                        <div className="service-item">
                                            <div className="service-icon">
                                                <i className="fab fa-aws text-primary"></i>
                                            </div>
                                            <h4>Gestione Amazon AWS</h4>
                                            <p>
                                                Amministrazione e ottimizzazione di servizi AWS esistenti: EC2, S3, 
                                                RDS, Lambda e tutti i servizi dell'ecosistema Amazon Web Services.
                                            </p>
                                        </div>
                                    </Col>
                                    
                                    <Col lg={6} className="mb-4">
                                        <div className="service-item">
                                            <div className="service-icon">
                                                <i className="fas fa-cloud-upload-alt text-primary"></i>
                                            </div>
                                            <h4>Migrazione al Cloud</h4>
                                            <p>
                                                Supporto completo per la migrazione di applicazioni e dati da 
                                                infrastrutture on-premise al cloud, minimizzando i tempi di 
                                                inattività e garantendo la continuità operativa.
                                            </p>
                                        </div>
                                    </Col>
                                    
                                    <Col lg={6} className="mb-4">
                                        <div className="service-item">
                                            <div className="service-icon">
                                                <i className="fas fa-server text-primary"></i>
                                            </div>
                                            <h4>Cloud Privato e Hosting</h4>
                                            <p>
                                                Possiamo ospitare i servizi esistenti dei tuoi clienti sul nostro 
                                                cloud privato, offrendo soluzioni ibride che combinano la sicurezza 
                                                del privato con la flessibilità del cloud pubblico.
                                            </p>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mb-5">
                    <Col lg={12}>
                        <Card className="service-card">
                            <Card.Body>
                                <h2 className="section-title">Tipologie di Cloud che Gestiamo</h2>
                                
                                <Row>
                                    <Col md={4} className="text-center mb-4">
                                        <div className="cloud-type">
                                            <div className="cloud-icon">
                                                <i className="fas fa-cloud text-primary"></i>
                                            </div>
                                            <h5>Cloud Pubblico</h5>
                                            <p>
                                                Gestione di risorse su piattaforme cloud pubbliche come 
                                                Google Cloud, AWS e Microsoft Azure per massima scalabilità.
                                            </p>
                                        </div>
                                    </Col>
                                    
                                    <Col md={4} className="text-center mb-4">
                                        <div className="cloud-type">
                                            <div className="cloud-icon">
                                                <i className="fas fa-lock text-primary"></i>
                                            </div>
                                            <h5>Cloud Privato</h5>
                                            <p>
                                                Creazione e gestione di cloud privati dedicati per massima 
                                                sicurezza e controllo dei dati aziendali.
                                            </p>
                                        </div>
                                    </Col>
                                    
                                    <Col md={4} className="text-center mb-4">
                                        <div className="cloud-type">
                                            <div className="cloud-icon">
                                                <i className="fas fa-network-wired text-primary"></i>
                                            </div>
                                            <h5>Cloud Ibrido</h5>
                                            <p>
                                                Soluzioni ibride che combinano cloud pubblico e privato 
                                                per ottimizzare performance, costi e sicurezza.
                                            </p>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mb-5">
                    <Col lg={12}>
                        <Card className="service-card">
                            <Card.Body>
                                <h2 className="section-title">Vantaggi delle Nostre Soluzioni Cloud</h2>
                                
                                <Row>
                                    <Col md={6} className="mb-3">
                                        <div className="advantage-item">
                                            <i className="fas fa-users-cog text-primary"></i>
                                            <strong>Expertise Dedicato</strong>
                                            <p>Team specializzato in architetture cloud e best practices</p>
                                        </div>
                                    </Col>
                                    
                                    <Col md={6} className="mb-3">
                                        <div className="advantage-item">
                                            <i className="fas fa-clock text-primary"></i>
                                            <strong>Supporto 24/7</strong>
                                            <p>Monitoraggio continuo e supporto tecnico sempre disponibile</p>
                                        </div>
                                    </Col>
                                    
                                    <Col md={6} className="mb-3">
                                        <div className="advantage-item">
                                            <i className="fas fa-tachometer-alt text-primary"></i>
                                            <strong>Ottimizzazione Performance</strong>
                                            <p>Analisi e ottimizzazione continua delle performance</p>
                                        </div>
                                    </Col>
                                    
                                    <Col md={6} className="mb-3">
                                        <div className="advantage-item">
                                            <i className="fas fa-dollar-sign text-primary"></i>
                                            <strong>Cost Optimization</strong>
                                            <p>Riduzione dei costi attraverso ottimizzazione delle risorse</p>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col lg={12}>
                        <Card className="service-card cta-card">
                            <Card.Body className="text-center">
                                <h3>Pronto a Modernizzare la Tua Infrastruttura?</h3>
                                <p className="mb-4">
                                    Contattaci per una valutazione gratuita della tua infrastruttura attuale 
                                    e scopri come il cloud può trasformare il tuo business.
                                </p>
                                <a href="#contact" className="btn btn-primary btn-lg">
                                    Richiedi Valutazione Gratuita
                                </a>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default CloudSolutions;